<section
  class="profile-editor"
  aria-labelledby="profile-editor-title"
  [attr.aria-busy]="isSaving()"
>
  <button
    type="button"
    class="profile-editor__back"
    [disabled]="isSaving()"
    (click)="cancel.emit()"
  >
    <lib-icon
      class="profile-editor__back-icon"
      iconName="backIcon"
      aria-hidden="true"
    ></lib-icon>

    <span class="profile-editor__back-text"> Back </span>
  </button>

  <header class="profile-editor__header">
    <div class="profile-editor__identity">
      <lib-icon
        class="profile-editor__avatar"
        iconName="adopterProfileIcon"
        aria-hidden="true"
      ></lib-icon>

      <h1 id="profile-editor-title" class="profile-editor__title">
        {{ adopter().firstName }}
        {{ adopter().lastName }}
      </h1>
    </div>
  </header>

  <div class="profile-editor__status-notice">
    <ng-content select="[profile-edit-notice]" />
  </div>

  <div class="profile-editor__body" [attr.aria-label]="title()">
    <ng-content select="[profile-edit-fields]" />
  </div>

  <footer class="profile-editor__footer">
    @if (notice(); as noticeText) {
      <lib-ds-notice
        class="profile-editor__notice"
        type="informational"
        [message]="noticeText"
        [hideClose]="true"
      />
    }

    <button
      type="button"
      class="petszel-primary-button profile-editor__save"
      [disabled]="isSaving() || saveDisabled()"
      (click)="onSave()"
    >
      {{ isSaving() ? savingLabel() : saveLabel() }}
    </button>
  </footer>
</section>
